var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRlbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FEA103;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000132065053229572677840000000597715133636129926_",
    className: "st1",
    d: "M489.7,206.6c129.2,0,234,104.8,234,234 s-104.8,234-234,234c-5.7,0-11.3-0.2-16.9-0.6l-368.9-16.1l341.8-30.1l-98.2-1.3c-28.8-22-52.2-50.6-68.3-83.4l-100.2-10.5 l91.4-9.9c-9.6-25.5-14.8-53.2-14.8-82c0-28.9,5.2-56.5,14.8-82l-91.4-9.9l100.2-10.5c16-32.9,39.5-61.4,68.3-83.4l98.2-1.3 l-341.8-30.1l367.8-16C477.7,206.9,483.7,206.6,489.7,206.6z M489.7,352.9c-48.5,0-87.7,39.3-87.7,87.7s39.3,87.7,87.7,87.7 s87.7-39.3,87.7-87.7S538.2,352.9,489.7,352.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlbIcon);
export default __webpack_public_path__ + "static/media/rlb_icon.8fd8278c35b7c30baf9bfb649f675e78.svg";
export { ForwardRef as ReactComponent };